import { TaxonomyActionTypeNames, TaxonomyActionTypes } from './actionTypes';
import {
  WindTaxonomy,
  TaxonomyCustomerAdmin,
  TaxonomyCountryCustomer,
  TaxonomyCustomerBrand,
  TaxonomyOperations,
  TaxonomySystemInfoAdmin,
  TaxonomyAssetInfoAdmin,
  TaxonomyAssetManufacturer,
  ModifyAsset,
  BearingToPost,
  TaxonomySystemInfoAdminCompleted,
  TaxonomyBearingInfoAdmin,
  IassetKeyUpdate,
  ITurbineDeletedInfo,
  TaxonomyAssetNameBearings,
  ITaxonomyUpload,
} from './types';
import { ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ITaxonomyCutomerState, ITaxonomyState } from './store';
import { apiClient } from '../../services/apiService';

export const getErrorStatusFromError = (err: any) =>
  parseInt(err.message.split(' ').reverse()[0] || '0', 10);

export const fetchTaxonomy: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = () => async (dispatch: Dispatch<TaxonomyActionTypes>) => {
  await apiClient
    .get<WindTaxonomy[]>(`/api/admin/taxonomy`)
    .then((res) => {
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_ALL_SUCCESS,
        isFetching: false,
        fetchStatus: res.status,
        taxonomy: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_ALL_ERROR,
        isFetching: false,
        fetchStatus: err?.response?.status,
      });
    });
};

export const deleteWindFarm: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (
  taxonomy: WindTaxonomy,
  okToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > deleteWindFarm');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const { data } = await apiClient.put<WindTaxonomy[]>(
        `/api/admin/taxonomy`,
        taxonomy
      );
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_WINDFARM_SUCCESS,
        taxonomy: data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const deleteTurbine: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (id: string, okToastr: () => void, errorToastr: () => void) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > deleteTurbine');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const { data } = await apiClient.delete<ITurbineDeletedInfo>(
        `/api/admin/taxonomy/${id}`
      );
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_TURBINE_BY_ID_SUCCESS,
        sectionSystemKey: data.sectionSystemKey,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const deleteAsset: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (id: string, okToastr: () => void, errorToastr: () => void) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > deleteTurbine');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const { data } = await apiClient.put<IassetKeyUpdate[]>(
        `/api/admin/deletetaxonomyassetinfo`,
        [{ AssetKey: id }]
      );
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_ASSET_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        assetKey: data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const deleteBearing: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (id: string, okToastr: () => void, errorToastr: () => void) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > deleteTurbine');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_WINDFARM_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      await apiClient.delete<string>(`/api/admin/taxonomy/taxonomyPart/${id}`);
      dispatch({
        type: TaxonomyActionTypeNames.DELETE_BEARING_SUCCESS,
        fetchStatus: '200',
        assetPartKey: id,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const GetIndustryTaxonomyCustomer: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (industry: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > GetIndustryTaxonomyCustomer');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.get<TaxonomyCustomerAdmin[]>(
        `/api/admin/TaxonomyIndustryCustomer?industry=${industry}`
      );
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_SUCCES,
        isFetching: false,
        fetchStatus: '200',
        taxonomyCustomer: response.data,
      });
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
    }
    return;
  };
};

export const GetBrandTaxonomyCustomer: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = () => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > GetBrandTaxonomyCustomer');

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.get<TaxonomyCustomerBrand[]>(
        `/api/admin/taxonomybrandcustomer`
      );
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_BRAND_TAXONOMY_CUSTOMER_SUCCES,
        isFetching: false,
        fetchStatus: '200',
        taxonomyBrand: response.data,
      });
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
    }
    return;
  };
};

export const PostAddNeWindFarm: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  taxonomyCustomers: TaxonomyCustomerAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostAddNeWindFarm');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.post<TaxonomyCustomerAdmin[]>(
        `/api/admin/addTaxonomyIndustryCustomer`,
        taxonomyCustomers
      );
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyCustomer: response.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const PostAddNewTurbine: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  taxonomyCustomers: TaxonomySystemInfoAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostAddNewTurbine');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const result = await apiClient.post<TaxonomySystemInfoAdminCompleted[]>(
        `/api/admin/addTaxonomySystemInfo`,
        taxonomyCustomers
      );
      dispatch({
        type:
          TaxonomyActionTypeNames.FETCH_INDUSTRY_TAXONOMY_CUSTOMER_POST_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomy: result.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const PostModifyAsset: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  assetToModify: ModifyAsset[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PutAsset');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const result = await apiClient.put<ModifyAsset>(
        `/api/admin/updateTaxonomyAssetInfo`,
        assetToModify
      );
      dispatch({
        type: TaxonomyActionTypeNames.PUT_ASSET_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAddAssetInfo: result.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const PostAddNewAsset: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (
  newAsset: TaxonomyAssetInfoAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void,
  turbineSelected?: string | number
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostNEW ASSET');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.POST_NEW_ASSET_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const result = await apiClient.post<TaxonomyAssetInfoAdmin[]>(
        `/api/admin/addTaxonomyAddAssetInfo`,
        newAsset
      );
      dispatch({
        type: TaxonomyActionTypeNames.POST_NEW_ASSET_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAddAssetInfo: result.data,
        turbineSelected: turbineSelected,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const PostUpdateWindFarm: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  taxonomyCustomers: TaxonomyCustomerAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostUpdateWindFarm');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.put<TaxonomyCustomerAdmin[]>(
        `/api/admin/updateTaxonomyIndustryCustomer`,
        taxonomyCustomers
      );
      dispatch({
        type: TaxonomyActionTypeNames.UPDATE_TAXONOMY_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyCustomer: response.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const PostUpdateTurbine: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  taxonomyCustomers: TaxonomySystemInfoAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostUpdateTurbine');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.ADD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.put<TaxonomySystemInfoAdmin[]>(
        `api/admin/updateTaxonomySystemInfo`,
        taxonomyCustomers
      );
      dispatch({
        type: TaxonomyActionTypeNames.PUT_TURBINE_SUCCESS,
        isFetching: false,
        fetchStatus: response.status.toString(),
        taxonomy: response.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const GetOperationsCustomer: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = () => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.GET_OPERATIONS_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.get<TaxonomyOperations[]>(
        `/api/admin/taxonomy/OperationsStatus`
      );

      dispatch({
        type: TaxonomyActionTypeNames.GET_OPERATIONS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyOperations: response.data,
      });
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
    }
    return;
  };
};

export const GetTaxonomyCountriesCustomer: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = () => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > GetOperationsCustomer');
    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.GET_COUNTRIES_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const response = await apiClient.get<TaxonomyCountryCustomer[]>(
        `/api/admin/taxonomycountrycustomer`
      );
      dispatch({
        type: TaxonomyActionTypeNames.GET_COUNTRIES_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyCountryCustomer: response.data,
      });
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
    }
    return;
  };
};

export const getBearings: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (plantUnitKey: string, sectionSystemKey: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    try {
      const response = await apiClient.get<TaxonomyAssetNameBearings[]>(
        `/api/admin/taxonomyassetnamebearing/${plantUnitKey}/${sectionSystemKey}`
      );
      dispatch({
        type: TaxonomyActionTypeNames.GET_BEARING_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAssets: response.data,
      });
    } catch (err) {
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_ASSETS_ERROR,
        isFetching: false,
        fetchStatus: '500',
      });
    }
  };
};

export const fetchAssets: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (plantUnitKey: string, sectionSystemKey: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    try {
      const response = await apiClient.get<TaxonomyAssetInfoAdmin[]>(
        `/api/admin/taxonomy/${plantUnitKey}/${sectionSystemKey}`
      );
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_ASSETS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAssets: response.data,
      });
    } catch (err) {
      dispatch({
        type: TaxonomyActionTypeNames.FETCH_ASSETS_ERROR,
        isFetching: false,
        fetchStatus: '500',
      });
    }
  };
};

export const getBearingParts: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (assetClassCode: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    try {
      const response = await apiClient.get<string[]>(
        `/api/admin/taxonomy/taxonomyPart/${assetClassCode}`
      );
      console.log('response', response);

      dispatch({
        type: TaxonomyActionTypeNames.GET_BEARING_POSITIONS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        bearingPositions: response.data,
      });
    } catch (err) {
      dispatch({
        type: TaxonomyActionTypeNames.GET_BEARING_POSITIONS_ERROR,
        isFetching: false,
        fetchStatus: '500',
      });
    }
  };
};

export const PostBearings: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  bearings: BearingToPost[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.POST_BEARINGS_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const result = await apiClient.post<TaxonomyBearingInfoAdmin[]>(
        `/api/admin/taxonomy/taxonomyParts`,
        bearings
      );
      dispatch({
        type: TaxonomyActionTypeNames.POST_BEARINGS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAddAssetInfo: result.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const ModifyBearings: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyCutomerState,
  null,
  TaxonomyActionTypes
>> = (
  bearings: TaxonomyBearingInfoAdmin[],
  okToastr: () => void,
  progressToastr: () => void,
  errorToastr: () => void
) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    console.log('>> redux > PostBearings');

    progressToastr();

    const dispatchError = (status: number, message: string) =>
      dispatch({
        type: TaxonomyActionTypeNames.POST_BEARINGS_ERROR,
        isFetching: false,
        fetchStatus: status.toString(),
        message,
      });
    try {
      const result = await apiClient.put<TaxonomyBearingInfoAdmin>(
        `/api/admin/taxonomy/taxonomyParts`,
        bearings
      );

      dispatch({
        type: TaxonomyActionTypeNames.PUT_BEARINGS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAddAssetInfo: result.data,
      });
      okToastr();
    } catch (err) {
      console.log(err);
      dispatchError(getErrorStatusFromError(err), err?.toString());
      errorToastr();
    }
    return;
  };
};

export const getAssetsManufacturerModels: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (assetClass: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    try {
      const response = await apiClient.get<TaxonomyAssetManufacturer[]>(
        `/api/admin/taxonomyassetmodelinfo?assetclass=${assetClass}`
      );

      dispatch({
        type: TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyAssetsManufacturerModel: response.data,
      });
    } catch (err) {
      dispatch({
        type: TaxonomyActionTypeNames.GET_ASSETS_MANUFACTURER_MODELS_ERROR,
        isFetching: false,
        fetchStatus: '500',
      });
    }
  };
};

export const fetchUploadTaxonomy: ActionCreator<ThunkAction<
  Promise<any>,
  ITaxonomyState,
  null,
  TaxonomyActionTypes
>> = (userEmail: string) => {
  return async (dispatch: Dispatch<TaxonomyActionTypes>) => {
    try {
      const response = await apiClient.get<ITaxonomyUpload[]>(
        `/api/admin/taxonomyHistoric?email=${userEmail}`
      );

      dispatch({
        type: TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_SUCCESS,
        isFetching: false,
        fetchStatus: '200',
        taxonomyUpload: response.data,
      });
    } catch (err) {
      dispatch({
        type: TaxonomyActionTypeNames.GET_UPLOAD_TAXONOMY_ERROR,
        isFetching: false,
        fetchStatus: '500',
      });
    }
  };
};
